export var VOLUME_FADE = {
  IN: 'in',
  OUT: 'out',
  NONE: 'none'
};